import {
  Lodash,
} from '@intelipost-js/secure-providers';

export default {
  setActiveStep(state, activeStep) {
    state.activeStep = activeStep;
  },
  nextStep(state) {
    state.activeStep += 1;
  },
  backStep(state) {
    state.activeStep -= 1;
  },
  toggleLoading(state, isLoading = false) {
    state.loading = isLoading;
  },
  setInstallationIdV2(state, installationId) {
    state.installationIdV2 = installationId;
  },
  setAppConfigV2(state, patch) {
    const clonedPatch = Lodash.cloneDeep(patch);
    const appConfig = state.appConfigV2;

    if (appConfig.per_warehouse && clonedPatch.per_warehouse) {
      clonedPatch.per_warehouse = clonedPatch.per_warehouse.map((warehouseConfig) => {
        const stateWarehouse = appConfig.per_warehouse
          .find(stateConfig => stateConfig.warehouse_id === warehouseConfig.warehouse_id);

        return { ...stateWarehouse, ...warehouseConfig };
      });
    }

    const newAppConfig = {
      ...appConfig,
      ...clonedPatch,
    };

    state.appConfigV2 = newAppConfig;
  },
  setCredentials(state, credentials) {
    state.credentials = credentials;
  },
  setAppDetails(state, appDetails) {
    state.appDetails = appDetails;
  },
  setWarehouseList(state, warehouseList) {
    state.warehouseList = warehouseList;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/store/mutations.js